/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Translations_CountInputs */

const en_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import ${i?.count} Translations`)
};

const fr_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importer ${i?.count} traductions`)
};

const de_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen importieren`)
};

const it_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importa ${i?.count} traduzioni`)
};

const ru_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импортировать ${i?.count} переводов`)
};

const es_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importar ${i?.count} traducciones`)
};

const zh_cn2_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入 ${i?.count} 个翻译`)
};

const ja_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}件の翻訳をインポート`)
};

const hi_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद आयात करें`)
};

const pt_pt2_import_translations_count = /** @type {(inputs: Import_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importar ${i?.count} traduções`)
};

/**
* | output |
* | --- |
* | "Import {count} Translations" |
*
* @param {Import_Translations_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_translations_count = /** @type {((inputs: Import_Translations_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Translations_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_import_translations_count(inputs)
	if (locale === "de") return de_import_translations_count(inputs)
	if (locale === "it") return it_import_translations_count(inputs)
	if (locale === "ru") return ru_import_translations_count(inputs)
	if (locale === "es") return es_import_translations_count(inputs)
	if (locale === "zh-CN") return zh_cn2_import_translations_count(inputs)
	if (locale === "ja") return ja_import_translations_count(inputs)
	if (locale === "hi") return hi_import_translations_count(inputs)
	if (locale === "pt-PT") return pt_pt2_import_translations_count(inputs)
	return en_import_translations_count(inputs)
});